/*global Vote, a*/
var DesktopHomepage = function() {
    return {
        init: function(date, period, ticker) {
            if (typeof MatchesTable == 'undefined') {
                return;
            }

            DesktopHomepage.date = date;
            DesktopHomepage.period = period;
            DesktopHomepage.ticker = ticker;

            if (Generic.getParam('_update_method') != 'push') {
                setTimeout(DesktopHomepage.matchesRefreshLoop, DesktopHomepage.period * 1000);
            }

            // order by buttons
            $('.ii__om_btn').click(function() {
                var order = $(this).data('orderby');
                if (order != undefined) {
                    DesktopHomepage.order_matches(order);
                }
            });
            $('#save_odds_company').change(function() {
                DesktopHomepage.saveOddsCompany($(this).val());
            });
            if (!(DesktopHomepage.ticker == 1)) {
                Vote.init();
            }
        },
        order_matches: function(ord) {
            if (ord == MatchesTable.byleague) {
                return;
            }
            if (ord == 'bytime') {
                $('.ii__om_time').addClass('active blue');
                $('.ii__om_league').removeClass('active blue');
            } else {
                $('.ii__om_time').removeClass('active blue');
                $('.ii__om_league').addClass('active blue');
            }
            Generic.showProgressLoader();
            MatchesTable.store_match_ordering(ord);
            DesktopHomepage.matchesRefresh();
        },
        applyAfterMatchLoad: function() {
            MatchesTable.applyAllFilters();
            Generic.init_popovers();
            if (!(DesktopHomepage.ticker == 1)) {
                Vote.init();
            }
            Generic.updateTimes();
            Generic.hideProgressLoader();
        },
        matchesRefresh: function() {
            return Ajax.getLive(
                DesktopHomepage.date,
                DesktopHomepage.ticker,
                MatchesTable.byleague,
                (res) => {
                    $('#results').html(res.html);
                    DesktopHomepage.applyAfterMatchLoad();
                });
        },
        matchesRefreshLoop: function() {
            DesktopHomepage.matchesRefresh().finally(function() {
                setTimeout(DesktopHomepage.matchesRefreshLoop, DesktopHomepage.period * 1000);
            });
        },
        saveOddsCompany: function(odds_company_id) {
            Generic.showProgressLoader();
            Ajax.savePrefOddsCompany(odds_company_id, () => {
                DesktopHomepage.matchesRefresh();
                DesktopHomepage.setTitleByOddsCompany(odds_company_id);
            });
        },
        setTitleByOddsCompany: function(odds_company_id) {
            var s = 'Αποτελέσματα Πάμε Στοίχημα ΟΠΑΠ';
            if (odds_company_id > 1) {
                s = 'Αποτελέσματα αγώνων';
            }
            $('#homepage_title h2').html(s);
        }
    };
}();
